import { gql } from '@biletiniz/apollo';

export const AIRLINES = gql`
  query airlines {
    airlines {
      code
      name
    }
  }
`;
